import React, { createContext, useContext } from 'react'
import { useAttributesInternal } from './hooks'
import type { UseAttributesReturnType } from './types'

export const AttributesContext = createContext<UseAttributesReturnType>(null)

export const AttributesProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const attributesAPI: UseAttributesReturnType = useAttributesInternal()
  return <AttributesContext.Provider value={attributesAPI}>{children}</AttributesContext.Provider>
}

export const useAttributes = () => {
  const context = useContext(AttributesContext)
  if (!context) {
    throw new Error('useAttributes must be wrapped within a AttributesProvider')
  }
  return context
}
